import React, { useState, useEffect } from "react";
import {
    FormControlLabel,
    ListItemText,
} from "@mui/material";
import Button from "components/CustomButtons/Button";
import CustomSwitch from "components/Input/CustomSwitch.js";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { AddCircleOutline } from "@mui/icons-material";
import List from "@mui/material/List";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import CustomSelect from "components/Input/CustomSelect.js";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import LineCondition from "components/Search/LineCondition";

const searchStyle = makeStyles(advancedSearchStyle);

function AdvancedSearch(props) {

    const { filters, handleFiltersChange, active, setActive, type, setType } = props;

    const conditionAnd = 'Et';
    const conditionOr = 'Ou';


    const addingAndCondition = () => {
        const id = uuid();
        const obj = {
            "item": "",
            "comparator": '',
            "value": '',
            "id": id,
            "itemChanged": true,
        };
        let newFilters = { ...filters };
        newFilters.andconditions.push(obj);
        handleFiltersChange(newFilters);
    }

    const removeAndCondition = (id) => {
        let newFilters = { ...filters };
        const remove = newFilters.andconditions;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newFilters.andconditions = remove;
        handleFiltersChange(newFilters);
    }

    const addingOrCondition = () => {
        const id = uuid();
        const obj = {
            "item": "",
            "comparator": '',
            "value": '',
            "id": id,
            "itemChanged": true,
        };
        let newFilters = { ...filters };
        newFilters.orconditions.push(obj);
        handleFiltersChange(newFilters);
    }

    const removeOrCondition = (id) => {
        let newFilters = { ...filters };
        const remove = newFilters.orconditions;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newFilters.orconditions = remove;
        handleFiltersChange(newFilters);
    }

    const handleConditionChange = () => {
        let newFilters = { ...filters };
        handleFiltersChange(newFilters);
    }

    const handleTypeChange = (event) => {
        setType(event.target.value);
        let newFilters = { andconditions: [], orconditions: [] };
        handleFiltersChange(newFilters);
    };

    const handleSwitchChange = (event) => {
        setActive(!active);
        let newFilters = { andconditions: [], orconditions: [] };
        setType('1.0');
        handleFiltersChange(newFilters);
    };

    const typedata = [
        { name: "Site", id: "1.0" },
        { name: "Bâtiment", id: "2.0" },
        { name: "Zone", id: "3.0" },
        { name: "Equipement urbain", id: "2.1" },
        { name: "Commune", id: "0.0" },
        { name: "EPCI", id: "0.1" },
        { name: "Groupe", id: "0.2" },
    ];
    const classes = searchStyle();
    return (
        <div>

            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <div>
                        <CustomSwitch
                            style={{margin: "0rem 0rem 0.3rem 1rem"}}
                            inputTitle={"Activer le filtrage avancé"}
                            checkedState={active}
                            handleSwitchChange={handleSwitchChange}
                        />
                    </div>
                </GridItem>
            </GridContainer>
            {active ?
                <><GridContainer>
                    <GridContainer>

                        <GridItem xs={12} sm={12}>
                            <CustomSelect
                                inputTitle={'Type de groupe'}
                                selectValue={type}
                                handleSelectValueChange={handleTypeChange}
                                data={typedata}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridItem xs={12} sm={12}>
                        <List component={"nav"}>
                            <ListItemText className={classes.listItemText}> Les groupes doivent remplir toutes ces conditions </ListItemText>

                            {
                                filters?.andconditions?.map((condition) => {
                                    return (
                                        <LineCondition
                                            key={condition.id} id={condition.id} obj={condition}
                                            removeCondition={() => removeAndCondition(condition.id)}
                                            whichCondition={conditionAnd}
                                            handleConditionChange={handleConditionChange}
                                            type={type}
                                        ></LineCondition>
                                    );
                                })
                            }
                        </List>

                        <FormControlLabel
                            value="addCondition"
                            className={classes.formControlLabel}
                            control={
                                <Button
                                    type="button" round
                                    color="transparent"
                                    justIcon size={"sm"}
                                    onClick={addingAndCondition}
                                >
                                    <AddCircleOutline> </AddCircleOutline>
                                </Button>
                            }
                            label=" Ajouter une condition "
                        />
                    </GridItem>
                </GridContainer>

                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <List component={"nav"}>
                                <ListItemText className={classes.listItemText}> Les groupes doivent remplir au moins une condition </ListItemText>
                                {
                                    filters?.orconditions?.map((condition) => {
                                        return (
                                            <LineCondition
                                                key={condition.id} id={condition.id} obj={condition}
                                                removeCondition={() => removeOrCondition(condition.id)}
                                                whichCondition={conditionOr}
                                                handleConditionChange={handleConditionChange}
                                                type={type}
                                            ></LineCondition>
                                        );
                                    })
                                }
                            </List>
                            <FormControlLabel
                                value="addCondition"
                                className={classes.formControlLabel}
                                control={
                                    <Button type="button" round color="transparent" justIcon size={"sm"}
                                        onClick={addingOrCondition}
                                    >
                                        <AddCircleOutline> </AddCircleOutline>
                                    </Button>
                                }
                                label=" Ajouter une condition"
                            />
                        </GridItem>
                    </GridContainer></>
                : <></>}
        </div>
    );

}
export default AdvancedSearch;

AdvancedSearch.propTypes = {
    open: PropTypes.bool,
    handleHideAdvancedSearch: PropTypes.func,
    handleHideAllModal: PropTypes.func,
    getAdvancedResultTree: PropTypes.func,
}